import { AuthConfig } from 'angular-oauth2-oidc';
import { RouteHelper, RouteNames } from '../route.name';

export const authCodeFlowConfig: AuthConfig = {
    redirectUri: RouteHelper.joinPath(window.location.origin, 'web', RouteNames.BASE, RouteNames.KREDIT_PORTAL_COCKPIT),
    postLogoutRedirectUri: RouteHelper.joinPath(window.location.origin, 'web', RouteNames.BASE, RouteNames.LOGOUT),
    responseType: 'code',
    scope: 'openid kreditportal profile email offline_access',
    showDebugInformation: false,
    oidc: true,
    requireHttps: true
}
